import styled from 'styled-components';

import JobReviewListHeader from './component';

import { listHeaderStyles } from 'modules/fleet/list';

export default styled(JobReviewListHeader)`
  ${listHeaderStyles}
`;
